import { FormattedMessage, useIntl } from "react-intl";

import Modal from "@components/Modal";
import { Opener } from "@hooks/useOpener";
import dataTableStyles from "@theme/DataTable.module.css";
import { JourneyStatusEnum } from "@typing/Generated";
import { imageUrl } from "@utils/imageUtils";

type Props = {
  opener: Opener;
};

const JourneyStatusModal = ({ opener }: Props) => {
  const intl = useIntl();

  return (
    <Modal fullscreen opener={opener} title={intl.formatMessage({ id: "pages.expert.journeys.status" })}>
      {() => (
        <>
          <table className={`${dataTableStyles.dataTable}`}>
            <thead>
              <tr>
                <th>
                  <FormattedMessage id="pages.expert.journeys.status" />
                </th>
                <th>
                  <FormattedMessage id="pages.expert.journeys.statuses.definition" />
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                JourneyStatusEnum.SIGNED_UP,
                JourneyStatusEnum.AWAITING_INITIAL_CONSULT,
                JourneyStatusEnum.AWAITING_INITIAL_CONSULT_RESCHEDULE,
                JourneyStatusEnum.CARE_PLAN_IN_PROGRESS,
                JourneyStatusEnum.CARE_PLAN_PUBLISHED,
                JourneyStatusEnum.FOLLOW_UP_CONSULT_SCHEDULED,
                JourneyStatusEnum.ENGAGED,
                JourneyStatusEnum.INACTIVE,
                "active_for_renewals"
              ].map(status => (
                <tr key={status}>
                  <td>
                    <FormattedMessage id={`pages.expert.journeys.statuses.${status}.title`} />
                  </td>
                  <td>
                    <FormattedMessage id={`pages.expert.journeys.statuses.${status}.description`} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            <img src={imageUrl("clientStatuses")} />
          </div>
        </>
      )}
    </Modal>
  );
};

export default JourneyStatusModal;
